<template>
    <div class="cdiv">
        <div class="header flex">
            <div>
                <el-image class="weiziiconst" :src="require('../assets/img/dingwei.png')" fit="cover"></el-image>
            </div>
            <div class="pleft">
                当前位置：<span>首页</span><span>>常用旅客</span><span>>修改</span>
            </div>
        </div>
        <div class="hc flex">

            <el-form size="small" :inline="true" ref="form" :model="form" label-width="80px" class="formstylejp">

                <el-form-item label="" class=" fsizestyle" prop="sendcity">

                    <span class="spanstyles" v-if="danwei != null && danwei != ''">
                        <span class="labelspanstyle">部门名称：</span> <el-input class="inputstyle heightstyle"
                            placeholder="请输入" v-model="form.deptname" disabled="disabled" clearable></el-input>
                    </span>
                    <span class="spanstyles">
                        <span class="labelspanstyle">姓名：</span> <el-input class="inputstyle heightstyle"
                            placeholder="请输入" v-model="form.xingming" disabled="disabled" clearable></el-input>
                    </span>
                    <span class="spanstyles">
                        <span class="labelspanstyle">手机号码：</span> <el-input class="inputstyle heightstyle"
                            placeholder="请输入" v-model="form.phone" clearable></el-input>
                    </span>
                </el-form-item>

                <el-form-item label="" class=" fsizestyle" prop="sendcity">

                    <span class="spanstyles">
                        <span class="labelspanstyle">性别：</span> <el-select class="inputstyle"  disabled="disabled" v-model="form.xingbie"
                            placeholder="选择">
                            <el-option label="男" value="1"></el-option>
                            <el-option label="女" value="2"></el-option>
                        </el-select>
                    </span>
                    <span class="spanstyles">
                        <span class="labelspanstyle">人员类型：</span> <el-select class="inputstyle"  disabled="disabled" v-model="form.rytype"
                            placeholder="选择">
                            <el-option label="成人" value="1"></el-option>
                            <el-option label="儿童" value="2"></el-option>
                            <el-option label="学生" value="3"></el-option>
                        </el-select>
                    </span>
                </el-form-item>


            </el-form>


        </div>
        <div class="hctwo flex">

            <el-form size="small" :inline="true" ref="form" :model="form" label-width="80px" class="formstylejp">


                <el-form-item label="" class=" fsizestyle" prop="sendcity">

                    <span class="spanstylestwo">
                        证件类型： <el-select class="inputstyle" v-model="form.zjleixing"  disabled="disabled" placeholder="选择">
                            <el-option label="身份证" value="1"></el-option>
                            <el-option label="护照" value="2"></el-option>
                        </el-select>
                    </span>
                    <span class="spanstylesthree">
                        证件号码： <el-input class="inputstyle heightstyle"  disabled="disabled" placeholder="请输入" v-model="form.zjnumber"
                            clearable></el-input>
                    </span>

                </el-form-item>
                <el-row>
                    <el-form-item label="" class=" fsizestyle" prop="sendcity">
                        <div class="pcdiv flex">
                            <div>证件照片：</div>
                            <div class="imgzhengmian">
                                <el-upload :fileList="zmfileList" :on-success="handleSuccessCardZhengmian"
                                    action="/api/api/passenger/frequentlyinfo/uploadimginfo" list-type="picture-card"
                                    :limit="1">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <!--
                            <el-image class="weiziicon" :src="require('../assets/img/shenfenzheng012x.png')"
                                      fit="cover"></el-image>
                                      -->
                            </div>
                            <div class="imgfanmian">
                                <!--
                           <el-image class="weiziicon" :src="require('../assets/img/shenfenzheng022x.png')"
                                     fit="cover"></el-image>
                                     -->
                                <el-upload :fileList="fmfileList"   :on-success="handleSuccessCardFanmian"
                                    action="/api/api/passenger/frequentlyinfo/uploadimginfo" list-type="picture-card"
                                    :limit="1">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </div>
                    </el-form-item>
                </el-row>

            </el-form>


        </div>
        <div class="savebtndiv">
            <el-button class="savebtn" @click="savebtn">提交</el-button>
        </div>


        <div class="copyright">
            工业和信息化部备案管理系统网站 豫B1-20080191-28
        </div>
    </div>
</template>

<script>
import ElImage from "element-ui/packages/image/src/main";
import ElButton from "element-ui/packages/button/src/button";
import { updatepassengerinfo, querypassengerbyId,querycompanybyphone } from '../api/index';
import Cookie from 'js-cookie';
export default {
    components: {
        ElButton,
        ElImage
    },
    data() {
        return {
            activeName: 'first',
            danwei: '',
            fileList: [],
            zmfileList: [],
            fmfileList: [],
            form: {
                deptname: '',
                xingming: '',
                phone:'',
                xingbie:'',
                rytype:'',
                zjleixing: '',
                zjnumber: '',
                cardzhengmianImg: '',
                cardfanmianImg: '',
            },
            cardzhengmianImg: '',
            cardfanmianImg: '',
            objpg: {},
            rules: {
                mobilephone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],

                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],

            }
        }
    },
    activated() {
        const idstr = this.$route.query.pgId;
        this.querypassengerinfo(idstr);
        const user = Cookie.get('phoneKey');
        //根据手机号查询会员信息
        this.querymemberbyPhone(user);

    },
    methods: {
        querymemberbyPhone(phonestr) {
            const params = { mobilePhone: phonestr };
            const p = this.$querystring.stringify(params);
            querycompanybyphone(p).then(res => {
                this.danwei = res.data.data.ret[0].danwei;

        })
        },
        //上传证件照正面
        handleSuccessCardZhengmian(res, file) {
            this.cardzhengmianImg = res.data.ret;

        },
        //上传证件照反面
        handleSuccessCardFanmian(res, file) {
            this.cardfanmianImg = res.data.ret;

        },
        //根据id查询常旅客信息
        querypassengerinfo(idstr) {
            const params = { pgId: idstr };
            const p = this.$querystring.stringify(params);
            querypassengerbyId(p).then(res => {
                this.objpg = res.data.data.ret[0];
                this.form.deptname = this.objpg.deptname;
                this.form.xingming = this.objpg.xingming;
                this.form.phone = this.objpg.pgPhone;
                this.form.xingbie = this.objpg.xingbie;
                this.form.rytype = this.objpg.personType;
                this.form.zjleixing = this.objpg.idType;
                this.form.zjnumber = this.objpg.idNumber
                this.zmfileList = [{
                    name: 'zhengmian',
                    url: this.objpg.idImgZhengmian
                }]

                this.fmfileList = [{
                    name: 'fanmian',
                    url: this.objpg.idImgFanmian
                }]
                this.cardfanmianImg = this.objpg.idImgFanmian;
                this.cardzhengmianImg = this.objpg.idImgZhengmian;
            })
        },
        validateSfz(value) {
            if (!value || value.length !== 18) {
                // this.$message.error('请输入正确的身份证号');
                return false
            }
            return true
        },
        savebtn() {
            const user = Cookie.get('phoneKey');
            const danweistr=this.danwei;
            var deptnamestr = this.form.deptname;
            const xingmingstr = this.form.xingming;
            const phonestr = this.form.phone;
            const xingbiestr = this.form.xingbie;
            const rytypestr = this.form.rytype;
            const idtypestr = this.form.zjleixing;
            const zjnumstr = this.form.zjnumber;
            const cardzmingstr = this.cardzhengmianImg;
            const cardimgfanmianstr = this.cardfanmianImg;
            const cdept=Cookie.get('deptKey');
            if(""!=cdept && null!=cdept){
                deptnamestr=cdept;
            }
            if(""!=danweistr && null!=danweistr) {
                if ("" == deptnamestr || null == deptnamestr) {
                    this.$message.warning('请输入部门名');
                    return;
                }
            }
            if ("" == xingmingstr || null == xingmingstr) {
                this.$message.warning('请输入姓名');
                return;
            }
            if ("" == phonestr || null == phonestr) {
                this.$message.warning('请输入手机号');
                return;
            }

            if (!(/^1(3|4|5|7|8|9|6)\d{9}$/i.test(phonestr))) {
                this.$message.warning('手机号错误');
                return;
            }
            if ("" == xingbiestr || null == xingbiestr) {
                this.$message.warning('请选择性别');
                return;
            }
            if ("" == rytypestr || null == rytypestr) {
                this.$message.warning('请选择人员类型');
                return;
            }
            if ("" == zjnumstr || null == zjnumstr) {
                this.$message.warning('请输入证件号码');
                return;
            }
            if("1"==idtypestr && !this.validateSfz(zjnumstr)){
                this.$message.warning('身份证号码错误');
                return;
            }
            if ("" == cardzmingstr || null == cardzmingstr) {
                this.$message.warning('请上传身份证正面');
                return;
            }
            if ("" == cardimgfanmianstr || null == cardimgfanmianstr) {
                this.$message.warning('请上传身份证反面');
                return;
            }
            const params = {
                deptname: deptnamestr,
                xingming: xingmingstr,
                pgPhone: phonestr,
                xingbie: xingbiestr,
                personType: rytypestr,
                idType: idtypestr,
                idNumber: zjnumstr,
                idImgZhengmian: cardzmingstr,
                idImgFanmian: cardimgfanmianstr,
                mobilePhone: user,
                pgId: this.$route.query.pgId
            }
            updatepassengerinfo(params).then(res => {
                if (res.data.code && res.data.code === 200) {

                    this.$message.success('修改成功');
                    this.$router.push('/passenger');
                } else {
                    var msgstr = res.data.msg;
                    this.$message.error('修改失败:' + msgstr);

                }
            })
        }
    },
    name: "passengerupdate-right"
}
</script>

<style scoped>

.labelspanstyle {
    display: inline-block;
    width: 70px;
    margin-left: 10px;
}

.pcdiv {
    padding-top: 1vh;
    margin-left: 20px;
}

.imgzhengmian {}

.imgfanmian {
    margin-left: 1vw;
}

.savebtndiv {
    width: calc(88% - 0px - 10px) !important;
    margin-top: 3vh;
    text-align: center;


}

.savebtn {
    background-color: #42B134;
    color: #FFFFFF;
    width: 400px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

.spanstylestwo {
    width: 20vw;
    display: inline-block;
    margin-left: 20px;

}

.spanstylesthree {
    width: 20vw;
    display: inline-block;
    margin-left: 12px;
    margin-right: 20px;

}

.spanstyles {
    width: 20vw;
    display: inline-block;
    margin-left: 10px;
}

.tcontentwidth {
    width: calc(60% - 0px - 0px) !important;
}

.rightoper {
    margin-top: 30px;
}

.shuxian {
    height: 180px;
    font-size: 1px;
    width: 1px;
    border-right: 1px dashed rgba(66, 177, 52, 1);

    margin-left: 30px;
}

.defaultbtn {
    background-color: #42B134;
    color: #FFFFFF;
}

.hcpdiv {
    margin-top: 2vh;
    background-color: #F1F1F1;
    width: 200px;
    padding-top: 2vh;
    padding-left: 1.6vw;
    border-top-right-radius: 20px;
    border-top-left-radius: 6px;

}

.titlecolor {}

.xiancolor {
    color: rgba(66, 177, 52, 1);
}

.hcpicon {
    width: 20px;
    height: 27px;
}

.dfkcolor {
    color: rgba(100, 100, 100, 1);
}

.mleft {
    margin-left: 16px;
}

.titlecolor {
    color: rgba(66, 177, 52, 1);
}

.mttop {
    margin-top: 1vh;
}

.weiziiconst {
    width: 24px;
    height: 24px;
}

.inputstyle {
    width: 10vw;
}

.cdiv {}

.xiadandate {
    color: #646464;
    font-size: 12px;
    margin-left: 10vw;
}

.xiadaninfo {
    margin-left: 1.8vw;
    margin-top: 3vh;
    color: #646464;
    font-size: 12px;

}

.mtopstyle {
    margin-left: 1vw;
    margin-top: 1vh;
}

.hengxian {
    border-bottom: 1px solid rgba(34, 172, 56, 1);
    margin-left: 2vw;
}

.paycolor {
    color: #42B134;
    border: 1px solid #42B134;
    width: 100px;
    height: 35px;
    text-align: center;
}

.mstyle {
    width: 100px;
    text-align: center;

}

.operbtn {
    margin-left: 30px;
    margin-top: 8vh;

}

.redcolorstyle {
    color: #FF7342;
    font-weight: bolder;
}

.bluecolor {
    color: #22AC38;
}

.sficon {
    margin-left: 0.5vw;
}

.tabwidth {
    width: calc(88% - 0px - 10px) !important;
    background-color: #F1F1F1;
    margin-top: 3vh;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

.weiziiconsj {
    width: 16px;
    height: 16px;
    padding-left: 1.2vw;
}

.iconleft {
    margin-left: 0.5vw;
    margin-top: 0.2vh;
}

.datestrs {
    margin-left: 0.5vw;
}

.traindatediv {
    background-color: #F1F1F1;
    width: calc(88% - 0px - 10px) !important;
    border-top-right-radius: 20px;
    padding-top: 20px;

}

.copyright {
    width: calc(88% - 0px - 10px) !important;
    font-size: 12px;
    text-align: center;
    margin-top: 5vh;
    color: #B6B6B6;
}

.mleftmargin {
    margin-left: 1vw;
}

.pager {
    margin-top: 5vh;
    margin-left: 0vw;
    width: calc(88% - 0px - 10px) !important;
    display: flex;
    justify-content: center;

}

.shouye {}

.sybtn {
    width: 100px;
    height: 35px;
    border: 1px solid #666666;
    text-align: center;
}

.btnnodiv {
    margin-left: 1vw;
}

.btnno {
    width: 50px;
    height: 35px;
    border: 1px solid #666666;
    text-align: center;
}

.commonmtop {
    margin-top: 2vh;
}

.btnmargin {
    margin-top: 1vh;
}

.btnstyle {
    width: 100px;
    height: 35px;
    background-color: #42B134;
    color: #FFFFFF;
    border-radius: 5px;
}

.checizuowei {
    margin-left: 5vw;
}

.colorstyle {
    color: #F49200;
    font-weight: bolder;
}

.checileixing {
    margin-left: 5vw;
}

.checimoney {
    margin-left: 5vw;
}

.zwleixing {
    margin-top: 0.1vh;
}

.cmtopzw {
    margin-top: 2vh;
}

.cxinfo {
    margin-left: 2vw;
}

.endcheci {
    margin-left: 3vw;
}

.sleft {
    margin-left: 1vw;
}

.scheci {
    margin-left: 2vw;

}

.startzhan {
    margin-left: 1vw;
}

.scdiv {
    margin-top: 2vh;
}

.sccdate {
    font-size: 20px;
    font-weight: bolder;
    margin-left: 1vw;
}

.haoshi {
    margin-left: 3vw;
}

.tcontent {
    background-color: #F1F1F1;
    height: 180px;
    width: calc(88% - 0px - 10px) !important;
    margin-top: -1vh;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
}

.mleftd {
    margin-left: -2vw;
}

.querybtn {
    background-color: #42B134;
    color: #FFFFFF;
    border-radius: 5px;
    margin-left: 1vw;
    width: 100px;
}

.trainorderstyle {
    margin-left: 1vw;
}

.formstyle {
    padding-top: 2.2vh;
}

.container {}

.header {
    font-size: 12px;
}

.flex {
    display: flex;
}

.weiziicon {}

.pleft {
    margin-left: 0.5vw;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
}

.hctwo {
    background-color: #F1F1F1;
    width: calc(88% - 0px - 10px) !important;
    height: 240px;
    margin-top: 2vh;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

.hc {
    background-color: #F1F1F1;
    width: calc(88% - 0px - 10px) !important;
    height: 130px;
    margin-top: 2vh;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

.formstylejp {
    padding-top: 2.2vh;
}

button:hover {
    background-color: #42B134;
    color: #FFFFFF;
}
</style>
